import PropTypes from "prop-types"
import ActiveUsers from "./active_users"
import Categories from "./categories"
import ServiceEngagements from "./service_engagements"
import ServicesConnected from "./services_connected"
import UsersConnected from "./users_connected"

const AllTime = ({
  engagementsTotal,
  topCategories,
  topServices,
  appletRunsTotal,
  appletRatingsTotal,
  appletEnablesTotal,
  ctaClicksTotal,
  usersTotal,
  activeUsersTotal,
  categoriesTotal,
  connectedServicesTotal,
  categoriesUrl,
  servicesUrl,
}) => (
  <>
    <div className="module">
      <ServiceEngagements
        engagementsTotal={engagementsTotal}
        appletRunsTotal={appletRunsTotal}
        appletEnablesTotal={appletEnablesTotal}
        appletRatingsTotal={appletRatingsTotal}
        ctaClicksTotal={ctaClicksTotal}
      />
    </div>
    <div className="module">
      <UsersConnected usersTotal={usersTotal} />
      <ActiveUsers activeUsersTotal={activeUsersTotal} />
    </div>
    <div className="module">
      <Categories
        categoriesTotal={categoriesTotal}
        topCategories={topCategories}
        categoriesUrl={categoriesUrl}
      />
    </div>
    <div className="module">
      <ServicesConnected
        servicesTotal={connectedServicesTotal}
        topServices={topServices}
        servicesUrl={servicesUrl}
      />
    </div>
  </>
)

AllTime.propTypes = {
  engagementsTotal: PropTypes.number.isRequired,
  categoriesTotal: PropTypes.number.isRequired,
  topCategories: PropTypes.array.isRequired,
  appletRunsTotal: PropTypes.number.isRequired,
  appletRatingsTotal: PropTypes.number.isRequired,
  appletEnablesTotal: PropTypes.number.isRequired,
  ctaClicksTotal: PropTypes.number.isRequired,
  usersTotal: PropTypes.number.isRequired,
  activeUsersTotal: PropTypes.number.isRequired,
  connectedServicesTotal: PropTypes.number.isRequired,
  topServices: PropTypes.array.isRequired,
  categoriesUrl: PropTypes.string.isRequired,
  servicesUrl: PropTypes.string.isRequired,
}

export default AllTime
